import styled from '@emotion/styled';
import { css } from '@emotion/core';

const Wrapper = styled.div`
  ${({ width, responsive }) =>
    width &&
    css`
      width: ${width}px;
      ${responsive
        ? css`
            max-width: ${width}px;
          `
        : ''}
    `}
  display: flex;
  flex: 1;
`;

const Bar = styled.div`
  ${({ width, height, color, radius }) =>
    width &&
    css`
      width: ${width}px;
      height: ${height}px;
      background-color: ${color};
      border-radius: ${radius / 2}px;
    `}
`;

const calcBarWidth = (width, radius, percentage) => {
  const w = parseInt(width, 10);
  const r = parseInt(radius, 10);
  const p = Math.max(0, Math.min(100, parseInt(percentage, 10)));
  return ((w - r) * p) / 100 + r;
};

const PercentageBar = ({
  percentage,
  width = 100,
  radius = 10,
  primaryColor = 'var(--color-viz-cat-1-primary)',
  backgroundColor = 'var(--color-border-medium-light)',
  responsive,
}) => {
  const barWidth = calcBarWidth(width, radius, percentage);
  return (
    <Wrapper width={width} responsive={responsive}>
      <Bar
        width={width}
        height={radius}
        color={backgroundColor}
        radius={radius}
      >
        <Bar
          width={barWidth}
          height={radius}
          color={primaryColor}
          radius={radius}
        />
      </Bar>
    </Wrapper>
  );
};

export default PercentageBar;
